// removed by extract-text-webpack-plugin
module.exports = {"text":"_8DxXTxhf8FqtG_lUJeF3p","avatar":"_3wRt1DI5roStEvlKLnHnPo","box":"_2ZgNDq63LtVqx4T5Nzb0j_"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/NotificationItem/style.css
// module id = 505
// module chunks = 38